import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faInfoCircle as faInfoCircleLight } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { faInfoCircle as faInfoCircleSolid } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import classNames from 'classnames/bind';

import Styles from '../story-filters-styles.module.scss';
import { sourcesTabs } from '../../../data/filters/storyFilters';
import Tooltip from '../../Tooltip';
import Preloader from '../../Preloader';

const cx = classNames.bind(Styles);

export const DomainsSelectionInfo = ({ sourceCategory }) => (
  <>
    {sourceCategory === 'all' && (
      <p className={Styles['sources-selection-description']}>You will see content from all sources</p>
    )}
    {sourceCategory === 'whitelist' && (
      <p className={Styles['sources-selection-description']}>You will see content ONLY from these sources</p>
    )}
    {sourceCategory === 'blacklist' && (
      <p className={Styles['sources-selection-description']}>You will see NO content from these sources</p>
    )}
  </>
);

export const SelectedSourceType = ({ domainFilteringMode }) => (
  <p>
    {domainFilteringMode === 'all' && 'All Sources'}
    {domainFilteringMode === 'blacklist' && 'Blocked Sources'}
    {domainFilteringMode === 'whitelist' && 'Selected Sources'}
  </p>
);

export const SourceSettingsModalTitle = ({
  width, cancel, domainsSelectionFeature, openedTab, saveDisabled, save,
}) => (
  <div className={Styles['advanced-settings-title']}>
    {width >= 768 ? (
      <span>Content Settings</span>
    ) : (
      <>
        {openedTab === 'general' && (
          <span>General Settings</span>
        )}
        {openedTab === 'manageSources' && (
          <span>Manage Sources</span>
        )}
      </>
    )}
    <SourceSettingsModalBtns
      cancel={cancel}
      save={save}
      openedTab={openedTab}
      saveDisabled={saveDisabled}
      domainsSelectionFeature={domainsSelectionFeature}
      mobileBtns
    />
  </div>
);

export const SourcesSettingsMobileControls = ({ selectMobileTab, domainFilteringMode }) => (
  <div className={Styles['source-settings-mobile']}>
    <p className={Styles['mobile-title']}>SETTINGS</p>
    <button
      type="button"
      onClick={() => selectMobileTab('general')}
    >
      General
      <FontAwesomeIcon icon={faChevronRight} />
    </button>
    <button
      type="button"
      onClick={() => selectMobileTab('manageSources')}
    >
      <div className="flex-column justify-content-center">
        Manage Sources
        <SelectedSourceType domainFilteringMode={domainFilteringMode} />
      </div>
      <FontAwesomeIcon icon={faChevronRight} />
    </button>
  </div>
);

export const SourcesSearchScreen = ({
  selectedDomainCategory, domains, filterSelectedDomains, selectDomain, sourceCategory,
  setDomainCategory, limitReached,
}) => {
  const listClass = cx({
    'domains-list': true,
    'select-domains-active': true,
  });

  const allDomainsSearchResult = (domainsItems, isPremium, major, others) => domainsItems.filter((item) => item.is_premium === isPremium
    || item.major === major
    || (!item.is_premium && !item.major && others)).slice(0, 6);

  return (
    <div className={Styles['search-domains-screen']}>
      {selectedDomainCategory === 'premium' && domains.length > 0 && (
        <p className={Styles['premium-source-info']}>
          All Premium sources in one list. Some sources are both Premium and free.
          Use the Content Source Filter to toggle Premium-only content.
        </p>
      )}
      <div>
        {limitReached && (
          <p className={Styles['domains-list-limit']}>100 / 100 selected. You’ve reached the limit</p>
        )}
        <div className={Styles['all-domains-list-wrapper']}>
          {domains.length > 0 ? (
            <>
              {sourcesTabs.slice(1).map(({
                key, id, fullTitle, major, is_premium: isPremium, others,
              }) => (
                <AllDomainsResultList
                  key={id}
                  keyItem={key}
                  id={id}
                  sourceCategory={sourceCategory}
                  selectDomain={selectDomain}
                  domains={domains}
                  isPremium={isPremium}
                  major={major}
                  others={others}
                  allDomainsSearchResult={allDomainsSearchResult}
                  filterSelectedDomains={filterSelectedDomains}
                  setDomainCategory={setDomainCategory}
                  listClass={listClass}
                  fullTitle={fullTitle}
                />
              ))}
            </>
          ) : (
            <p className={Styles['no-domains-found']}>No results found</p>
          )}
        </div>
      </div>
    </div>
  );
};

const AllDomainsResultList = ({
  sourceCategory, selectDomain, domains, isPremium, major, others,
  allDomainsSearchResult, filterSelectedDomains, setDomainCategory, keyItem, listClass,
  fullTitle,
}) => {
  const list = allDomainsSearchResult(domains, isPremium, major, others);

  return (
    <>
      {list.length > 0 && (
        <div className={Styles['domains-category-item']}>
          <div className={Styles['domains-category-item__title']}>
            <h2>{fullTitle}</h2>
            {list.length === 5 && (
              <button
                type="button"
                className={Styles['change-category']}
                onClick={() => setDomainCategory(keyItem)}
              >
                Show More
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            )}
          </div>
          {keyItem === 'premium' && (
            <p className={Styles['premium-source-info']}>
              Some sources provide both free and Premium content. Hide non-Premium content
              separately.
            </p>
          )}
          <ul className={listClass}>
            {list.slice(0, 5).map(({ id, name }) => (
              <li
                key={id}
                className={cx('parent_checkbox', { active: filterSelectedDomains(id, sourceCategory) })}
                onClick={() => selectDomain(id, sourceCategory)}
              >
                <span className={cx('checkbox_box')}>
                  {!!filterSelectedDomains(id, sourceCategory) && (
                    <FontAwesomeIcon icon={faCheck} />
                  )}
                </span>
                {name}
              </li>
            ))}
          </ul>
          {list.length >= 5 && (
            <button
              type="button"
              className={Styles['change-category']}
              onClick={() => setDomainCategory(keyItem)}
            >
              Show More
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          )}
        </div>
      )}
    </>
  );
};

export const SourcesInfo = ({
  getSourcesQuantity, selectedDomainCategory, selectedDomains, unselectAllDomains,
  sourceCategory, limitReached, isLoading,
}) => (
  <div className={Styles['sources-info']}>
    <div className="d-flex align-items-center flex-wrap">
      <Preloader
        loading={isLoading}
        static
        centered
        className={Styles.preloader}
      />
      <p>
        {getSourcesQuantity(selectedDomainCategory)}
        {' '}
        available
      </p>
      {sourceCategory !== 'all' && (
        <>
          <span className={Styles['sources-info__divider']} />
          <p className={cx({ limit: limitReached })}>
            {selectedDomains}
            {' '}
            / 100 selected
            {limitReached && (
              <span>
                .
                {' '}
                You’ve reached the limit
              </span>
            )}
          </p>
          <Tooltip
            className="info-tooltip"
            icon={(
              <div className={Styles['tooltip-icon']}>
                <FontAwesomeIcon icon={faInfoCircleSolid} />
                <FontAwesomeIcon icon={faInfoCircleLight} />
              </div>
            )}
          >
            For now, you can only select up to 100 sources
          </Tooltip>
        </>
      )}
    </div>
    {sourceCategory !== 'all' && (
      <p
        className={cx('unselect-all-sources', { disabled: selectedDomains < 1 })}
        onClick={() => unselectAllDomains(sourceCategory)}
      >
        Unselect All
      </p>
    )}
  </div>
);

export const SourceSettingsModalBtns = ({
  cancel, domainsSelectionFeature, openedTab, saveDisabled, save, mobileBtns,
}) => (
  <div className={cx('source-settings-modal-btns', { 'mobile-btns': mobileBtns })}>
    <button
      className={cx('advanced-settings', 'advanced-settings--reset')}
      onClick={cancel}
      type="button"
    >
      Cancel
    </button>
    <button
      className={cx('advanced-settings', 'advanced-settings--save',
        { disabled: (!domainsSelectionFeature && openedTab !== 'general') || saveDisabled })}
      onClick={save}
      type="button"
    >
      Save
    </button>
  </div>
);
